import { useSelector } from 'react-redux';
import { selectRoles } from 'store/profile';
import {
  ROLE_CAREER_MENTOR,
  ROLE_PEOPLE_PARTNER,
  ROLE_REVIEW_CYCLE_MANAGER,
  ROLE_REVOPS_MANAGER,
} from 'constants/roles';

export default function useUserRoles() {
  const roles = useSelector(selectRoles);
  const isPeoplePartner = roles.find(
    (role) => role.alias === ROLE_PEOPLE_PARTNER,
  );
  const isCareerMentor = roles.find(
    (role) => role.alias === ROLE_CAREER_MENTOR,
  );
  const isRevOpsManager = roles.find(
    (role) => role.alias === ROLE_REVOPS_MANAGER,
  );
  const isReviewCycleManager = roles.find(
    (role) => role.alias === ROLE_REVIEW_CYCLE_MANAGER,
  );

  return {
    isPeoplePartner,
    isCareerMentor,
    isRevOpsManager,
    isReviewCycleManager,
  };
}
